import type { ISMELogoProps } from '../../ShipmentLogo';
import { MerchantDefaultLogo, MerchantLogoWithLogo } from '../CommonLogos';

const SMELogo = ({ smeLogo, merchantName, size = 'small' }: Omit<ISMELogoProps, 'variant'>) => {
  if (smeLogo) {
    return <MerchantLogoWithLogo logo={smeLogo} merchantName={merchantName} size={size} />;
  }
  if (merchantName) {
    return <MerchantDefaultLogo merchantName={merchantName} size={size} />;
  }

  console.error('SMELogo: logo and merchantName is not provided');
  return null;
};

export { SMELogo };
